import { render, staticRenderFns } from "./ItemInputAdd.vue?vue&type=template&id=573f37bc&"
import script from "./ItemInputAdd.vue?vue&type=script&lang=js&"
export * from "./ItemInputAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports